
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/components/theme/theme-provider";
import { LanguageProvider } from "@/components/i18n/language-provider";
import ScrollToTop from "./components/layout/ScrollToTop";
import RouteTracker from "./components/analytics/RouteTracker";

// Pages
import Index from "./pages/Index";
import Pricing from "./pages/Pricing";
import Products from "./pages/Products";
import Solutions from "./pages/Solutions"; // Add the Solutions import
import Workforce from "./pages/Workforce";
import Business from "./pages/Business";
import CIAM from "./pages/CIAM";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import NotFound from "./pages/NotFound";
import ComingSoon from "./pages/ComingSoon";
import About from "./pages/About";
import PrivacySecurity from './pages/PrivacySecurity';
import Comparison from './pages/Comparison';

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <LanguageProvider defaultLanguage="en-US">
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
            <RouteTracker />
            <Routes>
              <Route path="/" element={<Index />} />
              {/* Redirect Pricing page to ComingSoon */}
              <Route path="/pricing" element={<Navigate to="/coming-soon" replace />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/workforce" element={<Workforce />} />
              <Route path="/products/business" element={<Business />} />
              <Route path="/products/ciam" element={<CIAM />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/solutions/healthcare" element={<Solutions />} />
              <Route path="/solutions/retail" element={<Solutions />} />
              <Route path="/solutions/insurance" element={<Solutions />} />
              <Route path="/comparison" element={<Comparison />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/contact/thank-you" element={<ThankYou />} />
              <Route path="/about" element={<About />} />
              <Route path="/coming-soon" element={<ComingSoon />} />
              <Route path="/privacy-security" element={<PrivacySecurity />} />
              {/* Redirect any other path to ComingSoon page */}
              <Route path="/features" element={<ComingSoon />} />
              <Route path="/resources" element={<ComingSoon />} />
              <Route path="/blog" element={<ComingSoon />} />
              <Route path="/support" element={<ComingSoon />} />
              {/* 404 route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
